/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalGenerationConfig,
  EvalGenerationConfig$inboundSchema,
  EvalGenerationConfig$Outbound,
  EvalGenerationConfig$outboundSchema,
} from "./evalgenerationconfig.js";

export type EvalScheduleRunConfig = {
  models: Array<string>;
  taskIds?: Array<string> | undefined;
  judgeModel?: string | undefined;
  embeddingModel?: string | undefined;
  generation?: EvalGenerationConfig | undefined;
  generationConcurrency?: number | undefined;
  concurrency?: number | undefined;
  graderConcurrency?: number | undefined;
  maxSamplesPerTask?: number | undefined;
  maxWorkflowSampleActivities?: number | undefined;
};

/** @internal */
export const EvalScheduleRunConfig$inboundSchema: z.ZodType<
  EvalScheduleRunConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  models: z.array(z.string()),
  task_ids: z.array(z.string()).optional(),
  judge_model: z.string().optional(),
  embedding_model: z.string().optional(),
  generation: EvalGenerationConfig$inboundSchema.optional(),
  generation_concurrency: z.number().int().optional(),
  concurrency: z.number().int().optional(),
  grader_concurrency: z.number().int().optional(),
  max_samples_per_task: z.number().int().optional(),
  max_workflow_sample_activities: z.number().int().optional(),
}).transform((v) => {
  return remap$(v, {
    "task_ids": "taskIds",
    "judge_model": "judgeModel",
    "embedding_model": "embeddingModel",
    "generation_concurrency": "generationConcurrency",
    "grader_concurrency": "graderConcurrency",
    "max_samples_per_task": "maxSamplesPerTask",
    "max_workflow_sample_activities": "maxWorkflowSampleActivities",
  });
});
/** @internal */
export type EvalScheduleRunConfig$Outbound = {
  models: Array<string>;
  task_ids?: Array<string> | undefined;
  judge_model?: string | undefined;
  embedding_model?: string | undefined;
  generation?: EvalGenerationConfig$Outbound | undefined;
  generation_concurrency?: number | undefined;
  concurrency?: number | undefined;
  grader_concurrency?: number | undefined;
  max_samples_per_task?: number | undefined;
  max_workflow_sample_activities?: number | undefined;
};

/** @internal */
export const EvalScheduleRunConfig$outboundSchema: z.ZodType<
  EvalScheduleRunConfig$Outbound,
  z.ZodTypeDef,
  EvalScheduleRunConfig
> = z.object({
  models: z.array(z.string()),
  taskIds: z.array(z.string()).optional(),
  judgeModel: z.string().optional(),
  embeddingModel: z.string().optional(),
  generation: EvalGenerationConfig$outboundSchema.optional(),
  generationConcurrency: z.number().int().optional(),
  concurrency: z.number().int().optional(),
  graderConcurrency: z.number().int().optional(),
  maxSamplesPerTask: z.number().int().optional(),
  maxWorkflowSampleActivities: z.number().int().optional(),
}).transform((v) => {
  return remap$(v, {
    taskIds: "task_ids",
    judgeModel: "judge_model",
    embeddingModel: "embedding_model",
    generationConcurrency: "generation_concurrency",
    graderConcurrency: "grader_concurrency",
    maxSamplesPerTask: "max_samples_per_task",
    maxWorkflowSampleActivities: "max_workflow_sample_activities",
  });
});

export function evalScheduleRunConfigToJSON(
  evalScheduleRunConfig: EvalScheduleRunConfig,
): string {
  return JSON.stringify(
    EvalScheduleRunConfig$outboundSchema.parse(evalScheduleRunConfig),
  );
}
export function evalScheduleRunConfigFromJSON(
  jsonString: string,
): SafeParseResult<EvalScheduleRunConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalScheduleRunConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalScheduleRunConfig' from JSON`,
  );
}
